module.exports = __webpack_public_path__ + "img/profile.8950c2c4.svg";